import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { ObjProfilTypeCred } from "../../core/model/obj-profil-type-cred";
import { UserProfile } from "../../core/model/user-profile";
import { TypeCredit } from "../../core/model/type-credit";
import { UserProfileService } from "../../core/service/user-profile.service";
import { TypeCreditService } from "../../core/service/type-credit.service";
import { ObjProfilTypeCredService } from "../../core/service/objectif-profil-type-credit.service";

@Component({
  selector: "app-add-objectif-profil-type-credit",
  templateUrl: "./add-objectif-profil-type-credit.component.html",
  styleUrls: ["./add-objectif-profil-type-credit.component.scss"],
})
export class AddObjectifProfilTypeCreditComponent implements OnInit {
  @Input() userProfileId;
  @Input() typeCreditId;

  objectif: ObjProfilTypeCred = new ObjProfilTypeCred();

  userProfile: UserProfile;

  typeCredit: TypeCredit;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _userProfileService: UserProfileService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _typeCreditService: TypeCreditService,
    private _objProfilTypeCredService: ObjProfilTypeCredService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      nbJourDossier: ["", Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getUserProfileById(this.userProfileId);
    this.getTypeCreditById(this.typeCreditId);
  }

  getUserProfileById(userProfileId) {
    this._userProfileService.getUserProfileById(userProfileId).subscribe(
      (data) => {
        this.userProfile = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getTypeCreditById(typeCreditId) {
    this._typeCreditService.getTypeCreditById(typeCreditId).subscribe(
      (data) => {
        this.typeCredit = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.objectif.userProfile = this.userProfile;
    this.objectif.typeCredit = this.typeCredit;
    this.pressButton = true;
    this._objProfilTypeCredService
      .postObjProfilTypeCred(this.objectif)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
